import { render, staticRenderFns } from "./wfSelectDialog.vue?vue&type=template&id=3c9742b7&scoped=true"
import script from "./wfSelectDialog.vue?vue&type=script&lang=js"
export * from "./wfSelectDialog.vue?vue&type=script&lang=js"
import style0 from "./wfSelectDialog.vue?vue&type=style&index=0&id=3c9742b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9742b7",
  null
  
)

export default component.exports